import React, { useEffect } from 'react';
import { useParams } from "react-router-dom";

import { useSharedData } from '../Contexts/SharedContext';
import { useLanguage } from '../Contexts/LanguageContext';
import { useTheme } from '../Contexts/ThemeContext';

import { getTranslatedValue } from '../Utils/getTranslatedText';

import Header from '../Components/Header/Header';
import Footer from '../Components/Footer/Footer';

import PageHeader from '../Components/PageHeader';
import Row from '../Components/Layout/Row';
import Wrapper from '../Components/Layout/Wrapper';

import { Paragraph } from '../Elements/Paragraph';

const ReadmorePage = () => {
    const { slug } = useParams();
    const { language } = useLanguage();
    const { content } = useSharedData();
    const { setTheme } = useTheme();
    
    const data = content?.exhibitions?.[slug] ?? null;

    const currentTheme = data?.theme ?? null;

    const title = data?.readmore?.hiddenTitle ?? null;
    const textItems = data?.readmore?.hiddenText || [];

    useEffect(() => {
        if (currentTheme) {
            setTheme(currentTheme);
        }
    }, [currentTheme, setTheme]);

    return (
        <>
            <Header withLanguageMenu={ false } withBackNavigation />
            <PageHeader title={ getTranslatedValue(title, language) } allCapsTitle />
            <div className="readmore-page">
                <Row>
                    <div className="readmore-page__content">
                        { textItems.map((item, idx) => {
                            const moreText = getTranslatedValue(item.text, language);
                            return (
                                <Paragraph 
                                    key={idx} 
                                    text={moreText} 
                                    withMarginBottom 
                                    isHtml={true}
                                    allowedTags={['br', 'strong', 'em']}
                                />
                            );
                        })}
                    </div>
                </Row>
            </div>
            <Footer />
        </>
    );
}

export default ReadmorePage;